function Loader() {
    return (
        <div className="pageLoader">
            <div className="text-center">Loading...</div>
        </div>
    );
}

export default Loader;